export const rangeFloat = (min, max) => {
    return Math.random() * (max - min) + min;
}

export const range = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}